import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {OrgAuthenticationView} from '@mintdata-wsp/wsp/ui/views/workspace/settings/organization/authentication/OrgAuthenticationView';
import {OrgMembersView} from '@mintdata-wsp/wsp/ui/views/workspace/settings/organization/members/OrgMembersView';
import {OrgGeneralView} from '@mintdata-wsp/wsp/ui/views/workspace/settings/organization/OrgGeneralView';
import {OrgSnippetsView} from '@mintdata-wsp/wsp/ui/views/workspace/settings/organization/snippets/OrgSnippetsView';
import {OrgSpacesView} from '@mintdata-wsp/wsp/ui/views/workspace/settings/organization/spaces/OrgSpacesView';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';
import {Route, RouteComponentProps} from 'react-router';
import {Link} from 'react-router-dom';

const styles = require('./SettingsPanel.less');
const cx = classnames.bind(styles);

export const enum SettingsRoutes
{
    General = 'general',
    Spaces = 'spaces',
    Members = 'members',
    Snippets = 'snippets',
    Authentication = 'authentication',
}

export interface ISettingsMenuItem
{
    title:string;
    subUrl:SettingsRoutes;
}

const DEFAULT_SETTINGS_PANEL = SettingsRoutes.General;

@observer
export class SettingsPanel extends React.Component<RouteComponentProps<any>, any>
{
    public static SettingsMenuItems:Array<ISettingsMenuItem> = [
        {
            title: `General`,
            subUrl: SettingsRoutes.General
        },
        {
            title: `Spaces`,
            subUrl: SettingsRoutes.Spaces
        },
        {
            title: `Members`,
            subUrl: SettingsRoutes.Members
        },
        {
            title: `Snippets`,
            subUrl: SettingsRoutes.Snippets
        },
        {
            title: `Authentication`,
            subUrl: SettingsRoutes.Authentication
        },
    ];

    private _renderRow = (item:ISettingsMenuItem) =>
    {
        const {match, location} = this.props;
        const linkTo = `${match.url}/${item.subUrl}`;
        const path = location.pathname;
        const isSelected = path === linkTo;

        return (
            <Row
                key={item.title + item.subUrl}
                className={cx(styles.settingsItem, {isSelected: isSelected})}
            >
                <Link
                    to={linkTo}
                    className={styles.link}
                >
                    {item.title}
                </Link>
            </Row>
        );
    };

    componentDidMount()
    {
        this._navigateToDefault();
    }

    componentWillReceiveProps()
    {
        this._navigateToDefault();
    }

    @bind
    private _navigateToDefault()
    {
        const {match} = this.props;
        const path = location.pathname;

        if( path === match.url )
            controllers.navigation.navigateTo(`${match.url}/${DEFAULT_SETTINGS_PANEL}`);
    }

    render()
    {
        const {match} = this.props;

        return (
            <Row className={cx(styles.settingsPanel)}>

                {/*<Row className={cx(styles.navColumnMobile)}>*/}

                {/*</Row>*/}

                <Column className={cx(styles.navColumn)}>
                    {SettingsPanel.SettingsMenuItems.map(this._renderRow)}
                </Column>

                <Column className={cx(styles.contentColumn)}>
                    <Route exact path={`${match.url}/${SettingsRoutes.General}`} component={OrgGeneralView} />
                    <Route exact path={`${match.url}/${SettingsRoutes.Spaces}`} component={OrgSpacesView} />
                    <Route exact path={`${match.url}/${SettingsRoutes.Members}`} component={OrgMembersView} />
                    <Route exact path={`${match.url}/${SettingsRoutes.Snippets}`} component={OrgSnippetsView} />
                    <Route exact path={`${match.url}/${SettingsRoutes.Authentication}`}
                           component={OrgAuthenticationView} />
                    {/*<Route exact path={`${match.url}/plans`} component={BillingPlansView}/>*/}
                    {/*<Route exact path={`${match.url}/payment-method`} component={BillingPaymentMethodView}/>*/}
                    {/*<Route exact path={`${match.url}/invoices`} component={BillingInvoicesView}/>*/}
                </Column>
            </Row>
        );
    }
}





